module.exports = __webpack_public_path__ + "media/images/athletes/419-128fe31ddaa62a179d69a02287ba9fbe.png";